const ForgotPasswordMixin = {

    data(){
        return {
            app: this.$root.$data.app,
        }
    },

    methods: {

        sendForgotPasswordResetEmail(email){
            return new Promise((resolve, reject) => {
                this.app.http.post('/user/forgotpassword', { email })
                    .then(response => {
                        resolve(true)
                        this.$ons.notification.alert(response.data.message, { title: '' })
                    })
                    .catch(error => {
                        // Show not resend email button
                        if (error.response && error.response.data && error.response.data.error == 'not_verified') {
                            this.$ons.notification.confirm(
                                error.response.data.message,
                                {title: '', buttonLabels: ['Close', 'Resend email']}
                            )
                            .then(result => {
                                if (result)
                                    return this.app.http.post('/user/verify/resend', { email })
                            })
                            .then(response => {
                                if (response) {
                                    this.$ons.notification.alert(response.data.message, {title: ''})
                                }
                            })
                        }
                        // Show other error reason
                        else {
                            this.$ons.notification.alert(this.app.getResponseErrorMessage(error), { title: 'Error' })
                        }
                        reject()
                    })
            })
        },

    },
}

export default ForgotPasswordMixin


// WEBPACK FOOTER //
// ./src/js/mixins/forgot_password.js